module.exports = "/_next/static/images/auto-6c2566cad7ca26ad9d52c9d390d34a89.svg";